export const truncateFileName = (fileName: string, maxLength: number = 15): string => {
  if (fileName.length <= maxLength) return fileName;

  const extension = fileName.split('.').pop() || '';
  const nameWithoutExt = fileName.slice(0, -(extension.length + (extension ? 1 : 0)));

  if (nameWithoutExt.length <= maxLength - (extension ? extension.length + 1 : 0)) return fileName;

  const maxNameOnlyLength = maxLength - (extension ? extension.length + 1 : 0);

  if (maxNameOnlyLength <= 3) {
    if (extension) {
      return nameWithoutExt.slice(0, 1) + '...' + '.' + extension;
    }
    return nameWithoutExt.slice(0, maxLength - 3) + '...';
  }

  const halfLength = Math.floor((maxNameOnlyLength - 3) / 2);
  const start = nameWithoutExt.slice(0, halfLength);
  const end = nameWithoutExt.slice(-halfLength);

  return `${start}...${end}${extension ? '.' + extension : ''}`;
};